'use client'

import { PropsWithChildren } from 'react'

function PartnershipPageWrapper({ children }: PropsWithChildren) {
  return (
    <main className="relative flex min-h-screen flex-1 flex-col overflow-hidden">{children}</main>
  )
}

export default PartnershipPageWrapper
